import React, {ReactNode, useEffect, useRef, useState} from "react";

export interface GlobalModalContextProps {
    isCreditModalOpen: boolean;
    setIsCreditModalOpen: (newVal: boolean) => void;
    isPricingPlanModalOpen: boolean;
    setIsPricingPlanModalOpen: (newVal: boolean) => void;
}

export interface GlobalModalContextProviderProps {
    children: ReactNode | ReactNode[];
}

export const defaultGlobalModalContextValue = {
    isCreditModalOpen: false,
    setIsCreditModalOpen: (newVal: boolean) => null,
    isPricingPlanModalOpen: false,
    setIsPricingPlanModalOpen: (newVal: boolean) => null,
}

export const GlobalModalContext = React.createContext<GlobalModalContextProps>(defaultGlobalModalContextValue);

export const GlobalModalContextProvider = ({ children }: GlobalModalContextProviderProps) => {
    const [isCreditModalOpen, setIsCreditModalOpen] = useState(false);
    const [isPricingPlanModalOpen, setIsPricingPlanModalOpen] = useState(false);

    return (
        <GlobalModalContext.Provider value={{
            isCreditModalOpen,
            setIsCreditModalOpen,
            isPricingPlanModalOpen,
            setIsPricingPlanModalOpen,
        }}>
            {children}
        </GlobalModalContext.Provider>
    );
}